const stepGroups: Record<string, string[]> = {
  "select-bank": ["select-bank-step"],
  "select-workflow-type": [
    "account-type-step",
    "select-new-or-existing-depot-step",
    "company-depot-terms-step",
  ],
  "register-or-signup-in-wizard": ["signup-step"],
  "natural-person": [
    "select-account-holder-type-step",
    "select-account-holder-step",
    "natural-person-personal-data-step",
    "natural-person-address-data-step",
    "has-second-legal-guardian-step",
  ],
  nationality: ["select-nationality-step"],
  "mifid-information": [
    "select-mifid-data-step",
    "mifid-fnz-data-step",
    "mifid-dab-data-step",
  ],
  "investment-experience": ["select-experience-step"],
  "bank-specific-details": [
    "account-identifier-step",
    "condition-model-step",
    "dws-product-category-step",
    "dab-mobile-for-tan-step",
    "fondsdepot-depot-type-step",
  ],
  payout: ["payout-data-step", "contra-account-data-step"],
  summary: ["cashback-summary"],
  taxation: ["final-tax-us-note-step", "select-taxation-step"],
};

export const getStepGroup = (stepId?: string) => {
  if (!stepId) return null;

  return Object.keys(stepGroups).find((key) =>
    stepGroups[key].includes(stepId)
  );
};
